import React from 'react';
type BillvastLogoProps = {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  textClassName?: string;
};
export const BillvastLogo: React.FC<BillvastLogoProps> = ({
  size = 'md',
  showText = false,
  textClassName = 'text-brand-text-dark'
}) => {
  const sizeMap = {
    sm: {
      icon: 28,
      text: 'text-lg',
      gap: 'gap-1.5'
    },
    md: {
      icon: 40,
      text: 'text-xl',
      gap: 'gap-2'
    },
    lg: {
      icon: 48,
      text: 'text-2xl',
      gap: 'gap-2.5'
    },
    xl: {
      icon: 64,
      text: 'text-3xl',
      gap: 'gap-3'
    }
  };
  const {
    icon,
    text,
    gap
  } = sizeMap[size];
  return <div className={`flex items-center ${gap}`} data-id="element-304">
      <img src="https://cdn.magicpatterns.com/uploads/4AEfCpc54BiEMtMYwDkd9o/Billvast_logo.png" alt="Billvast" width={icon} height={icon} className="shrink-0 object-contain" data-id="element-305" />
      {showText && <span className={`font-bold tracking-tight ${text} ${textClassName}`} data-id="element-306">
          Billvast
        </span>}
    </div>;
};